import { themePalette } from '../../utils/theme-palette';
import styled, { css } from 'styled-components';

export const SearchContainer = styled.div`
    z-index: 1;
    position: fixed;
    width: 90%;
    background: white;
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 40px;
`;

export const ItemsContainer = styled.div(
  ({theme}) => css`
      display: flex;
      flex-direction: column;
      gap: ${theme.spacing.m};
      overflow: scroll;
      margin-bottom: ${theme.spacing.m};
      margin-top: ${theme.spacing.xxl};
      padding-top: 40px;
  `
);

export const ItemContainer = styled.div(
  ({theme}) => css`
      display: flex;
      gap: 5px;
      justify-content: space-between;
      align-items: center;


      &.selectedHotel {
          background-color: ${theme.colors.seasalt};
          padding: ${theme.spacing.m} 0;
          border-color: ${theme.colors.platinum};
          border-width: 1px 0;
          border-style: solid;
          width: 100%;
      }
  `
);

export const ItemContent = styled.div`
    display: flex;
    justify-content: space-between;
    padding: 0 16px;
    width: 100%;
    align-items: center;
`;

export const NoResultContainer = styled.div(
  ({theme}) => css`
      display: flex;
      flex-direction: column;
      gap: ${theme.spacing.m};
      align-items: center;
  `
);

export const SearchTermContainer = styled.span`
    color: ${themePalette.lighgreen};
`;
